import React, { useState, useEffect } from "react";
import API from "../api.js"; // <-- import your Axios instance
import OptimizedImage from "./OptimizedImage";

const apiUrl = process.env.REACT_APP_API_BASE_URL;

const Promotion = () => {
    const [promoImages, setPromoImages] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // const apiUrl = 'http://localhost:4000';

    // Fetch promotions from API
    useEffect(() => {
        async function fetchPromotions() {
            try {
                const res = await API.get("/promotions");
                setPromoImages(res.data || []); // ensure it's an array
            } catch (err) {
                console.error("Error fetching promotions:", err);
                setError("Failed to load promotions. Please try again later.");
            } finally {
                setLoading(false);
            }
        }

        fetchPromotions();
    }, []);

    // Auto-advance slider every 5 seconds
    useEffect(() => {
        if (promoImages.length === 0) return;
        const interval = setInterval(() => {
            setCurrentIndex((prev) => (prev + 1) % promoImages.length);
        }, 5000);
        return () => clearInterval(interval);
    }, [promoImages]);

    const nextSlide = () =>
        setCurrentIndex((prev) => (prev + 1) % promoImages.length);

    const prevSlide = () =>
        setCurrentIndex((prev) => (prev - 1 + promoImages.length) % promoImages.length);

    const goToSlide = (index) => setCurrentIndex(index);

    // Handle loading and error states
    if (loading) {
        return (
            <div className="flex items-center justify-center h-64 text-gray-500">
                Loading promotions...
            </div>
        );
    }

    if (error) {
        return (
            <div className="flex items-center justify-center h-64 text-red-500">
                {error}
            </div>
        );
    }

    if (promoImages.length === 0) {
        return (
            <div className="flex items-center justify-center h-64 text-gray-500">
                No promotions available.
            </div>
        );
    }

    return (
        <div className="relative rounded-lg overflow-hidden shadow-lg h-full group">
            {/* Slides */}
            <div className="relative h-full min-h-[400px]">
                {promoImages.map((promo, index) => (
                    <a
                        key={promo.id}
                        href={"/contact"}
                        className={`absolute inset-0 transition-opacity duration-500 ${index === currentIndex ? "opacity-100" : "opacity-0"
                            }`}
                    >
                        <OptimizedImage
                            src={apiUrl+promo.image || "/assets/img/placeholder.png"}
                            alt={promo.title || 'ARU Promotion'}
                            className="w-full h-full object-cover"
                            width={800}
                            height={400}
                        />

                        <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>

                        {promo.badge && (
                            <div className="absolute top-4 right-4">
                                <span className="bg-red-600 text-white text-xs font-bold px-3 py-2 rounded-full shadow-lg">
                                    {promo.badge}
                                </span>
                            </div>
                        )}

                        {/* <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                            <h3 className="text-2xl font-bold mb-2">{promo.title}</h3>
                            <p className="text-sm opacity-90">Click to explore →</p>
                        </div> */}
                    </a>
                ))}
            </div>

            {/* Navigation Arrows */}
            <button
                onClick={prevSlide}
                className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white text-gray-800 w-10 h-10 rounded-full shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center"
                aria-label="Previous slide"
            >
                <i className="bi bi-chevron-left"></i>
            </button>

            <button
                onClick={nextSlide}
                className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white text-gray-800 w-10 h-10 rounded-full shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center"
                aria-label="Next slide"
            >
                <i className="bi bi-chevron-right"></i>
            </button>

            {/* Dots Navigation */}
            <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2 z-10">
                {promoImages.map((_, index) => (
                    <button
                        key={index}
                        onClick={() => goToSlide(index)}
                        className={`w-2 h-2 rounded-full transition-all duration-300 ${index === currentIndex
                                ? "bg-white w-8"
                                : "bg-white/50 hover:bg-white/75"
                            }`}
                        aria-label={`Go to slide ${index + 1}`}
                    />
                ))}
            </div>
        </div>
    );
};

export default Promotion;
